// Sentry must be first.
import { startSentry } from "./app/sentry.js";

import { startPostHog } from "./app/postHog.js";

declare global {
  function onAppStartError(): void;
}

async function startApp() {
  // Initialize Sentry as early as possible.
  const sentryManager = startSentry();

  // Initialize PostHog as early as possible.
  const postHogManager = startPostHog();

  // Load the data and view layers of the app.
  const [{ createStore }, { renderApp }] = await Promise.all([
    import("./app/store.js"),
    import("./app/i18n.js").then(() => import("./app/view.js")),
  ]);

  // Initialize the store.
  const store = createStore();
  store.subscribe(() => {
    sentryManager.onStoreChange(store.getState);
    postHogManager.onStoreChange(store.getState);
  });

  // Render the app.
  renderApp(store);
}

startApp().catch(onAppStartError);
